import { render, staticRenderFns } from "./add-notice.vue?vue&type=template&id=a1cda73c&scoped=true&"
import script from "./add-notice.vue?vue&type=script&lang=js&"
export * from "./add-notice.vue?vue&type=script&lang=js&"
import style0 from "./add-notice.vue?vue&type=style&index=0&id=a1cda73c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cda73c",
  null
  
)

export default component.exports